var React = require('react');

function Security (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M44.1562 17.9108L32.1562 12.2596C31.7907 12.0882 31.3989 12 31.0031 12C30.6074 12 30.2155 12.0882 29.85 12.2596L17.85 17.9108C16.7312 18.4335 16 19.6697 16 21.0401C16 35.062 23.1562 44.7537 29.8438 47.9042C30.5813 48.2504 31.4125 48.2504 32.15 47.9042C37.5062 45.3824 46 36.6726 46 21.0401C46 19.6697 45.2687 18.4335 44.1562 17.9108ZM31.0063 43.5246L31 16.611L41.9937 21.7889C41.7875 32.4837 36.8625 40.2328 31.0063 43.5246Z"}));
}

Security.defaultProps = {"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none"};

module.exports = Security;

Security.default = Security;
